let API = {
	getImgPath:function(){
		return ajaxUrl;
	},
	getPurchaserUrl:function(){
		return purchaserUrl;
	},
	getBrandUrl:function(){
		return brandUrl;
	},
	getRequirementUrl:function(){
		return requirementUrl;
	},
	getTradingHallUrl:function(){
		return tradingHallUrl;
	},
	getNewsUrl:function(){
		return newsUrl;
	},
	getExhibitionUrl:function(){
		return exhibitionUrl;
	},
	//验证普通会员、国内采购商、国外采购商的信息是否完善
    vailUserInfo: function (callback) {
        execute("/mobile/custom/vailUserInfo.htm", {
        	
        },callback);
    },
	//定制申请、打样申请
    customizeApply: function (type,apply_type,customize_desc,remark,
    	begin_delivery_time,quality_requirements,status,order_num,accessory_change_json,old_product_code,
    	old_goods_sku_str,pic_name,pic_path,attachment_name,attachment_path,callback) {
        execute("/mobile/custom/customize_apply.htm", {
            type:type,
            apply_type:apply_type,
            customize_desc:customize_desc,
            remark:remark,
            begin_delivery_time:begin_delivery_time,
            quality_requirements:quality_requirements,
            status:status,
            order_num:order_num,
            accessory_change_json:accessory_change_json,
            old_product_code:old_product_code,
            old_goods_sku_str:old_goods_sku_str,
            pic_name:pic_name,
            pic_path:pic_path,
            attachment_name:attachment_name,
            attachment_path:attachment_path
        },callback);
    },
	//查询商品列表
    getGoodsList: function (cabinetId,catCode,interval,currentPage,orderBy,orderAsc,shopCode,sortTime,pageSize,isQueryAll,goodsName,goodsNameEn,firstCatCode,brandId,productType,orderType,callback) {
        execute("/mobile/goods/ajax_goods_list.htm", {
            cabinetId:cabinetId,
            catCode:catCode,
            interval:interval,
            currentPage:currentPage,
            orderBy:orderBy,
            orderAsc:orderAsc,
            shopCode:shopCode,
            sortTime:sortTime,
            pageSize:pageSize,
            isQueryAll:isQueryAll,
            goodsName:goodsName,
            goodsNameEn:goodsNameEn,
            firstCatCode:firstCatCode,
            brandId:brandId,
            productType:productType,
            orderType:orderType
        },callback);
    },
    //根据一级类目查询二级类目
    getCategoryListByCode:function(parentCode,callback){
		execute("/mobile/category/get_category_list.htm",{
			parentCode:parentCode
		},callback);
    },
    //查询全部类目
    getAllCategoryMap:function(productType,callback){
		execute("/mobile/category/get_all_category_map.htm",{
			productType:productType
		},callback);
    },
    //根据一级类目查询二级类目
    getBrandList:function(callback){
		execute("/mobile/brand/ajax_query_list.htm",{
			
		},callback);
    },
    //查询实物商品详情
    getGoodPhysicalDetail:function(goodsCode,callback){
    	execute("/mobile/goods/ajax_goods_physical_detail.htm",{
    		goodsCode:goodsCode
    	},callback);
    },
    
    //查询虚拟产品详情
    getGoodDetail:function(goodsCode,callback){
    	execute("/mobile/goods/ajax_goods_detail.htm",{
    		goodsCode:goodsCode
    	},callback);
    },
    
    //查询购物车总数
    getShoppingCartNum:function(callback){
    	execute("/mobile/shoppingCart/ajax_total_num.htm",{
    		
    	},callback);
    },
    getOrderCount:function(callback){
    	execute("/mobile/order/ajax_order_count.htm",{
    		
    	},callback);
    },
    isExistCqPsd:function(callback){
    	execute("/mobile/user/cquc/exist_paypwd.htm",{
    		
    	},callback);
    },
    checkCqPsd:function(psd,callback){
    	execute("/mobile/user/cquc/check_paypwd.htm",{
    		"pwdCode":psd
    	},callback);
    },
    //判断是否存在未支付订单
    checkUnpaidOrder:function(goodsCode,callback){
    	execute("/mobile/order/ajax_unpaid_is_exist.htm",{
    		goodsCode:goodsCode
    	},callback);
    },
    
    //添加购物车
    addShoppingCart:function(goodsCode,goodsNumber,supplerAccount,goodsAttrValue,sellerAccount,specName,specNameEn,callback){
    	execute("/mobile/shoppingCart/ajax_add.htm",{
    		goodsCode:goodsCode,
    		goodsNumber:goodsNumber,
    		supplerAccount:supplerAccount,
    		goodsAttrValue:goodsAttrValue,
    		sellerAccount:sellerAccount,
    		specName:specName,
    		specNameEn:specNameEn
    	},callback);
    },
    //购物车列表
    getShoppingCartList:function(callback){
    	execute("/mobile/shoppingCart/ajax_shoppingCart_list.htm",{
    	},callback);
    },
    
    //登录
    login:function(account,password,callback){
    	execute("/mobile/login/ajax_dologin.htm",{
    		account:account,
    		password:password
    	},callback);
    },
    
    loginOut:function(callback){
    	execute("/mobile/login/login_out.htm",{
    		
    	},callback);
    },
    
    //获取验证码
    sendCode:function(mobile,callback){
    	execute("/mobile/sms/send_code.htm",{
    		mobile:mobile
    	},callback);
    },
    
    //手机号登录
    mobileLogin:function(mobile,checkCode,callback){
    	execute("/mobile/login/mobile_login.htm",{
    		mobile:mobile,
    		checkCode:checkCode
    	},callback);
    },
    
    //获取用户地址信息列表
    queryUserAddress:function(callback){
    	execute("/mobile/address/ajax_query_user_address.htm",{
    	},callback);
    },
    
    //获取指定ID的地址信息
    getOneAddress:function(addressId,callback){
    	execute("/mobile/address/ajax_get_one_address.htm",{
    		addressId:addressId,
    	},callback);
    },
    
    //获取地址信息
    setDefaultAddress:function(addressId,callback){
    	execute("/mobile/address/ajax_set_default_address.htm",{
    		addressId:addressId,
    	},callback);
    },
    //获取地址信息
    deleteAddress:function(addressId,callback){
    	execute("/mobile/address/ajax_delete_address.htm",{
    		addressId:addressId,
    	},callback);
    },
    
    //新增地址
    saveAddress:function(province,city,district,address,mobile,contextName,isEdit,id,zipcode,callback){
    	execute("/mobile/address/ajax_save_address.htm",{
    		province:province,
    		city:city,
    		district:district,
    		address:address,
    		mobile:mobile,
    		contextName:contextName,
    		isEdit:isEdit,
    		id:id,
    		zipcode:zipcode
    	},callback);
    },
    
    //订单列表
    getOrderList:function(currentPage,orderStatus,statusList,orderTime,callback){
    	execute("/mobile/order/ajax_order_list.htm",{
    		currentPage:currentPage,
    		orderStatus:orderStatus,
    		statusList:statusList,
    		orderTime:orderTime
    	},callback);
    },
    
    //订单详情
    getOrderDetail:function(id,tradeCode,callback){
    	execute("/mobile/order/ajax_order_detail.htm",{
    		id:id,
    		tradeCode:tradeCode
    	},callback);
    },
    
    //实物商品待确认订单
    getPhysicalOrderConfirm:function(goodsCode,payNum,specName,couponSubCode,shopCode,callback){
    	execute("/mobile/order/ajax_order_physical_confirm.htm",{
    		goodsCode:goodsCode,
    		payNum:payNum,
    		specName:specName,
    		couponSubCode:couponSubCode,
    		shopCode:shopCode
    	},callback);
    },
    
    //实物商品确认订单
    confirmPhysicalOrder:function(tradeType,goodOrder,discountInfo,buyerNote,addressId,isOnline,couponCode,userAccount,
    profit,couponSubCode,orderSource,distributeName,distributeAccount,discountType,receiptId,produceNum,quality,inspectionType,remark,callback){
    	execute("/mobile/order/ajax_submit_order_physical_confirm.htm",{
    		tradeType:tradeType,
    		goodOrder:goodOrder,
    		discountInfo:discountInfo,
    		buyerNote:buyerNote,
    		addressId:addressId,
    		isOnline:isOnline,
    		couponCode:couponCode,
    		userAccount:userAccount,
    		profit:profit,
    		couponSubCode:couponSubCode,
    		orderSource:orderSource,
	  		distributeName:distributeName,
			distributeAccount:distributeAccount,
			discountType: discountType,
			receiptId:receiptId,
			produceNum:produceNum,
			quality:quality,
			inspectionType:inspectionType,
			remark:remark
    	},callback);
    },
    //单店版本实物商品订单支付
    payPhysicalOrderCQSingleShop:function(packageCode,tradeCodes,callback){
    	execute("/mobile/fund/ajax_order_physical_pay_CQ_SingleShop.htm",{
    		packageCode:packageCode,
    		tradeCodes:tradeCodes
    	},callback);
    },     
    //多店版本实物商品订单支付(产权资金)
    payPhysicalOrderCQMultiShop:function(packageCode,tradeCodes,callback){
    	execute("/mobile/fund/ajax_order_physical_pay_CQ_MultiShop.htm",{
    		packageCode:packageCode,
    		tradeCodes:tradeCodes
    	},callback);
    },
    //多店版本实物商品订单支付(自有资金)
    payPhysicalOrderMultiShop:function(packageCode,tradeCodes,terminalType,prodCode,bankCode,callback){
    	execute("/mobile/fund/ajax_order_physical_pay_MultiShop.htm",{
    		packageCode:packageCode,
    		tradeCodes:tradeCodes,
    		terminalType:terminalType,
    		prodCode:prodCode,
        	bankCode:bankCode,
    	},callback);
    }, 
     //添加收藏
    addUserFavorite:function(favoriteType,goodsCode,shopCode,callback){
    	execute("/mobile/favorite/ajax_add.htm",{
    		favoriteType:favoriteType,
    		goodsCode:goodsCode,
    		shopCode:shopCode
    	},callback);
    },  
     //取消收藏
    deleteUserFavorite:function(goodsCode,shopCode,callback){
    	execute("/mobile/favorite/ajax_delete.htm",{
    		goodsCode:goodsCode,
    		shopCode:shopCode
    	},callback);
    }, 
     //删除收藏
    deleteFavoriteBycode:function(favoriteType,goodsCode,shopCode,callback){
    	execute("/mobile/favorite/ajax_delete.htm",{
    		favoriteType:favoriteType,
    		goodsCode:goodsCode,
    		shopCode:shopCode
    	},callback);
    },       
     //收藏是否存在
    isExistFavorite:function(favoriteType,goodsCode,shopCode,callback){
    	execute("/mobile/favorite/ajax_isExist.htm",{
    		favoriteType:favoriteType,
    		goodsCode:goodsCode,
    		shopCode:shopCode
    	},callback);
    },     
    //虚拟商品待确认订单
    getOrderConfirm:function(goodsCode,payNum,couponSubCode,callback){
    	execute("/mobile/order/ajax_order_confirm.htm",{
    		goodsCode:goodsCode,
    		payNum:payNum
    	},callback);
    },
    
    //虚拟商品确认订单
    confirmOrder:function(goodOrder,discountInfo,buyerNote,isOnline,orderSource,callback){
    	execute("/mobile/order/ajax_submit_order_confirm.htm",{
    		goodOrder:goodOrder,
    		discountInfo:discountInfo,
    		buyerNote:buyerNote,
    		isOnline:isOnline,
    		orderSource:orderSource
    	},callback);
    },
    
    //修改密码
    changePwd:function(pwd,againPwd,mobile,checkCode,callback){
    	execute("/mobile/user/change_pwd.htm",{
    		password:pwd, 
    		confirmPassword:againPwd, 
    		mobile:mobile, 
    		checkCode:checkCode
    	},callback);
    },
    //查询用户个人中心信息
    getUserInfo:function(callback){
    	execute("/mobile/user/ajax_user_info.htm",{
    	},callback);
    },
    
    cancelOrder:function(id,orderType,callback){
    	execute("/mobile/order/ajax_order_close.htm",{
    		id:id,
    		orderType:orderType
    	},callback);
    },
     //删除购物车的商品
    deleteGoods:function(ids,goodsCodes,callback){
    	execute("/mobile/shoppingCart/ajax_batch_delete.htm",{
    		goodsCodes: goodsCodes,
    			ids:ids
    	},callback);
    },
    //计算购物车商品金额
    sumGoodsPrice:function(goodsCodes,addressId,specNames,goodsNumbers,deliveryTypes,callback){
    	execute("/mobile/shoppingCart/ajax_sumShoppingCartGoodsPrice.htm",{
    		goodsCodes: goodsCodes,
    		addressId:addressId,
        	specNames:specNames,
        	goodsNumbers:goodsNumbers,
        	deliveryTypes:deliveryTypes
    	},callback);
    },
    //修改购物车的商品数量
    updateGoodsCount:function(goodsCode,goodsNumber,id,callback){
    	execute("/mobile/shoppingCart/ajax_update_shoppingCartCount.htm",{
    		goodsCode: goodsCode,
			goodsNumber: goodsNumber,
			id:id
    	},callback);
    },
    //修改购物车的商品数量
    getUserAddress:function(callback){
    	execute("/mobile/shoppingCart/user_address.htm",{
    		
    	},callback);
    },
    //获取购物车的商品
    getCartList:function(callback){
    	execute("/mobile/shoppingCart/ajax_list.htm",{
    		
    	},callback);
    },
    getCartListByCode:function(goodsCodes, specNames, addressId,callback){
    	execute("/mobile/shoppingCart/ajax_shoppingCart_list_by_code.htm",{
    		goodsCodes:goodsCodes,
			specNames: specNames,
			addressId: addressId
    	},callback);
    },
    getWeixinPackage:function(tradeCode,id,orderSrc,callback){
    	execute("/mobile/pay/weixin/data_package.htm",{
    		tradeCode:tradeCode,
    		id:id,
    		orderSrc:orderSrc
    	},callback);
    },
    //查询用户积分
    getPointsDetail:function(allcurrentPage, registcurrentPage, usecurrentPage,transCode, queryType, isFirst,pointType,pageSize,callback){
    	execute("/mobile//points/ajax_points_detail.htm",{
    		allcurrentPage:allcurrentPage, 
    		registcurrentPage:registcurrentPage, 
    		usecurrentPage:usecurrentPage, 
    		transCode:transCode, 
    		queryType:queryType, 
    		isFirst:isFirst, 
    		pointType:pointType,
    		pageSize:pageSize
    	},callback);
    },
    //购物车确认订单
    confirmCartOrder:function(goodOrder,discountInfo,buyerNote,addressId,isOnline,couponCode,userAccount,profit,couponSubCode,orderSrc,orderSource,callback){
    	execute("/mobile/order/ajax_submit_order_physical_confirm.htm",{
    		goodOrder:goodOrder,
    		discountInfo:discountInfo,
    		buyerNote:buyerNote,
    		addressId:addressId,
    		isOnline:isOnline,
    		couponCode:couponCode,
    		userAccount:userAccount,
    		profit:profit,
    		couponSubCode:couponSubCode,
    		orderSrc:orderSrc,
    		orderSource:orderSource
    	},callback);
    },
    //首页数据查询
    getIndexInfo:function(token,exchangeId,code,state,callback){
    	execute("/mobile/home/ajax_index.htm",{
    		token:token,
    		exchangeId:exchangeId,
    		code:code,
    		state:state
    	},callback);
    },
    //确认收货
    confirmReceived:function(tradeCode,callback){
    	execute("/mobile/order/receive_goods.htm",{
    		tradeCode:tradeCode
    	},callback);
    },
    
    getUserAddresses:function(callback){
    	execute("/mobile/address/ajax_get_address.htm",{
    	},callback);
    },
    
    getTradeInfo:function(tradeCode,callback){
    	execute("/mobile/order/order_tradeInfo.htm",{
    		tradeCode : tradeCode
    	},callback);
    },
    
    getShopInfo:function(shopCode,callback){
    	execute("/mobile/shop/ajax_shop.htm",{
    		shopCode:shopCode
    	},callback);
    },
    
    /*查询店铺首页广告*/
    getShopIndexAds:function(shopCode,callback){
    	execute("/mobile/shop/ajax_shop_index_ads.htm",{
    		shopCode:shopCode
    	},callback);
    },
    
    /*查询店铺首页友情链接*/
    getShopIndexLinks:function(shopCode,callback){
    	execute("/mobile/shop/ajax_shop_index_links.htm",{
    		shopCode:shopCode
    	},callback);
    },
    
    /*查询店铺评分*/
    getShopRate:function(shopCode,callback){
    	execute("/mobile/shop/ajax_shop_rate.htm",{
    		shopCode:shopCode
    	},callback);
    },
    
    getGoodCredits:function(goodsCode,currentPage,pageSize,callback){
    	execute("/mobile/credit/ajax_goods_credit.htm",{
    		goodsCode:goodsCode,
    		currentPage:currentPage,
    		pageSize:pageSize
    	},callback);
    },
    //查询首页广告及类目
    getIndex:function(callback){
    	execute("/mobile/home/ajax_index_info.htm",{
    		
    	},callback);
    },
    //查询店铺列表
    getShopList:function(shopName,shopNameEn,currentPage,shopType,pageSize,callback){
    	execute("/mobile/shop/ajax_shop_list.htm",{
    		shopName:shopName,
    		shopNameEn:shopNameEn,
    		currentPage:currentPage,
    		shopType:shopType,
    		pageSize:pageSize
    	},callback);
    },
    //查询所有类目
    getAllCat:function(productType,callback){
    	execute("/mobile/home/ajax_query_cat.htm",{
    		productType:productType
    	},callback);
    },
    //查询首页橱窗
    getIndexCabinet:function(callback){
    	execute("/mobile/home/ajax_query_cabinet.htm",{
    		
    	},callback);
    },
    getNews:function(callback){
    	execute("http://www.crtp.test:28020/sckb/index.htm?_=",{
    		_:'999'
    	},callback);
    },
    getShopGoodsByCat:function(shopCode,catCode,parentCode,callback){
    	execute("/mobile/shop/ajax_cat_goods.htm",{
    		shopCode:shopCode,
    		catCode:catCode,
    		parentCode:parentCode
    	},callback);
    },
    viewGoodsDetail:function(goodsCode,callback){
    	execute("/mobile/goods/ajax_view_goods_detail.htm",{
    		goodsCode:goodsCode
    	},callback);
    },
    //计算运费
    computeExpressFee:function(addressId,goodOrder,orderSource,callback){
    	execute("/mobile/express/ajax_computeExpressFee.htm",{
    		addressId:addressId,
    		goodOrder:goodOrder,
    		orderSource:orderSource
    	},callback);
    }, 
    
    //查询门店列表
    getStoreList:function(pointStr,city,callback){
    	execute("/mobile/order/ajax_store_list.htm",{
    		pointStr:pointStr,
    		city:city
    	},callback);
    },
    //查询首页推荐商品
    getRecommendGoods:function(pageSize,src,callback){
    	execute("/mobile/home/ajax_recommend_goods.htm",{
    		pageSize:pageSize,
    		src:src
    	},callback);
    },
    //查询首页推荐店铺
    getRecommendShops:function(pageSize,src,callback){
    	execute("/mobile/home/ajax_recommend_shops.htm",{
    		pageSize:pageSize,
    		src:src
    	},callback);
    },
    //查询首页广告
    getIndexAds:function(callback){
    	execute("/mobile/home/ajax_index_ads.htm",{
    	},callback);
    },
    //获取首页秒杀活动
    getSeckillActivityList:function(callback){
    	execute("/mobile/activity/ajax_get_seckill_list.htm",{
    	},callback);
    },
    getSeckillgoodsList:function(activityCode,currentPage,pageSize,callback){
    	execute("/mobile/activity/ajax_get_seckill_goods.htm",{
    		activityCode:activityCode,
    		currentPage:currentPage,
    		pageSize:pageSize
    	},callback);
    },
    //获取不同类型的发票类型
    getReceiptList:function(callback){
		execute("/mobile/receipt/ajax_get_receipt_list.htm",{
		},callback);
    },
    //保存企业发票
    saveReceipt:function(id, receiptType, receiptTitle,taxpayerNum,address,phone,openBank,openBankAccount,callback){
		execute("/mobile/receipt/save_receipt.htm",{
			id:id,
			receiptType:receiptType,
			receiptTitle:receiptTitle,
			taxpayerNum:taxpayerNum,
			address:address,
			phone:phone,
			openBank:openBank,
			openBankAccount:openBankAccount
		},callback);
   },
   checkPayStatus:function(orderNo,callback){
   		execute("/mobile/order/pay_status.htm",{
			orderNo:orderNo
		},callback);
   },
	//邮件询价
   sendContactSupplierEmail:function(productCode,quantityNum,valuationUnit, msgContext, emailAddress,callback){
   		execute("/mobile/goods/send_contact_supplier.htm",{
   			productCode: productCode,
			quantityNum:quantityNum,
			valuationUnit:valuationUnit,
			msgContext:msgContext,
			emailAddress:emailAddress
		},callback);
   },
};

import {ajaxUrl,purchaserUrl,brandUrl,requirementUrl,tradingHallUrl,newsUrl,exhibitionUrl} from "../js/emallUtils.js";

function execute(func, params,callback) {
		function _callback(ret){
			callback(ret);
		}
        return new Promise(function (resove, reject) {
            jQuery.ajax({
                type: "get",
                url: ajaxUrl + func,
                async:false,
                dataType : "jsonp", // 返回的数据类型，设置为JSONP方式
                data: params,
                success:_callback,
                error: function (err) {
                    reject(err);
                }
            })
        }).catch(function(err){
 			console.log("<<<<<<<<接口报错，func："+func+" params："+params+" err："+err);
 		});
}

//module.exports = API;
export default API;
var jsonp_callback;


// WEBPACK FOOTER //
// ./static/api/api.js